module.exports = __webpack_public_path__ + "img/account_pc_04.8f2a9862.png";